import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import {
  useApproveFloatMgtMutation,
  useDeclineFloatMgtMutation,
  useGetAllloatRequestsQuery
} from "../../../../api/employeeFloat";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  ActionButtons,
  CTAButtons,
} from "../../../../global/components/Buttons/buttons";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { FilterByStatus } from "../../Employee/FloatRequest/data";
import FeedbackApproveModal from "./modals/ApprovalModal";
import { SurveyDeclineModal } from "./modals/DeclineModal";
const purposes = [
  { label: "Business Development", value: 0 },
  { label: "Relationship Management", value: 1 },
];
const requestForOptions = [
  { label: "Self", value: 0 },
  { label: "Team", value: 1 },
];
const floatList = [
  {
    label: "Float Advance",
    value: 0,
  },
  {
    label: "Promotional Items",
    value: 1,
  },
  { label: "Perishables", value: 2 },
  {
    label: "Visitation",
    value: 3,
  },
];

const ManagementFloatRequest = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const [comment, setComment] = useState("");
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const navigate = useNavigate()
  const { data, isLoading } = useGetAllloatRequestsQuery({
    pageSize: pageSize,
    pageNumber: currentPage,
    searchText,
    filter,
    startDate,
    endDate,
  });
  const rows = data?.responseObject?.data || [];
  const rowIds = useMemo(
    () => rows.map((item) => item?.id).filter(Boolean),
    [rows],
  );
  const isAllSelected =
    rowIds.length > 0 && rowIds.every((id) => selectedIds.includes(id));
  const [approveFloat, { isLoading: approving }] = useApproveFloatMgtMutation();
  const [declineFloat, { isLoading: declining }] = useDeclineFloatMgtMutation();
  const handleSelectRow = (id, checked) => {
    if (!id) return;
    setSelectedIds((prev) => {
      if (checked) {
        if (prev.includes(id)) return prev;
        return [...prev, id];
      }
      return prev.filter((selectedId) => selectedId !== id);
    });
  };

  const handleSelectAll = (checked) => {
    if (!checked) {
      setSelectedIds([]);
      return;
    }
    setSelectedIds(rowIds);
  };


  const handleApprovalSubmit = async () => {
    try {
      const payload = {
        ids: selectedIds,
        comment,
      };
      const response = await approveFloat(payload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error wow:", error);
    }
  };
  const handleDeclineSubmit = async () => {
    try {
      const payload = {
        id: selectedIds,
        reason: comment,
      };
      const response = await declineFloat(payload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error wow", error);
    }
  };
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.responseObject?.data?.length > 0 ? (
    data?.responseObject?.data?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <input
              type="checkbox"
              checked={selectedIds.includes(item?.id)}
              onChange={(e) => handleSelectRow(item?.id, e.target.checked)}
              style={{ accentColor: "#5A7B53" }}
            />
          </td>
          <td>{index + 1}</td>
          <td>{item?.requestorName}</td>
          <td>
            {
              purposes.filter((purpose) => purpose.value === item?.purpose)[0]
                ?.label
            }
          </td>
          <td>
            {
              requestForOptions.filter(
                (requestFor) => requestFor.value === item?.requestFor,
              )[0]?.label
            }
          </td>
          <td>{item?.color}</td>
          <td>{item?.effectiveDate}</td>
          <td>{item?.noOfDays}</td>
          <td>
            {item?.floatTypes
              ?.map(
                (floatType) =>
                  floatList.find((float) => float.value === floatType)?.label,
              )
              .filter(Boolean)
              .join(", ")}
          </td>
          <td>{FormatDateTime(item?.submittedDate)}</td>
          <td>{item?.status}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view`}>
              {[
                {
                  name: "View",
                  action: () => handleView(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No results Found
      </td>
    </tr>
  );
  const actionButton = (
    <div className="flex items-center space-x-3">
      <CTAButtons onClick={handleApproveModal} disabled={approving || selectedIds.length === 0 }>
        {approving ? "Processing..." : `Approve (${selectedIds.length})`}
      </CTAButtons>
      <ActionButtons
        width={"auto"}
        className={DashboardStyle?.button_cage_weight}
        style={{ backgroundColor: "red" }}
        onClick={handleDeclineModal}
        disabled={declining || selectedIds.length === 0}
        type="button"
      >
        {declining ? "Processing..." : `Decline (${selectedIds.length})`}
      </ActionButtons>
    </div>
  );
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  return (
    <PageStyle hasBack={false} demoTitle={"FLOAT REQUESTS"} hasTopPageDemo>
      <div className="flex justify-between items-center">
        <form className={DashboardStyle.dashboard_filter}>
          <SearchFilter
            value={searchText}
            text={(searchText) => setSearchText(searchText)}
          />
          <CalendarFilter2
            name="Select Date Range"
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            normalDate
          />
          <ProDropFilter
            filter={filter}
            setFilter={setFilter}
            name={"Status"}
            filterBy={FilterByStatus}
          />
        </form>
        <div>{actionButton}</div>
      </div>
      <Table>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
                style={{ accentColor: "#5A7B53" }}
              />
            </th>
            <th>S/N</th>
            <th style={{ cursor: "pointer" }}>Request By</th>
            <th style={{ cursor: "pointer" }}>Purpose</th>
            <th style={{ cursor: "pointer" }}>Request For</th>
            <th>Color</th>
            <th style={{ cursor: "pointer" }}>Effective Date</th>
            <th style={{ cursor: "pointer" }}>No of Days</th>
            <th>Float Type</th>
            <th>Date Requested</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{tableContent}</tbody>
      </Table>
      <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.totalRows}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
      <FeedbackApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={handleApprovalSubmit}
        handleComment={handleComment}
        isLoading={approving}
        hasComment
        headText={"Approve Float"}
      />
      <SurveyDeclineModal
        openModal={openDeclineModal}
        closeModal={handleDeclineModal}
        handleComment={handleComment}
        handleDelete={handleDeclineSubmit}
        isLoading={declining}
      />
    </PageStyle>
  );
};

export default ManagementFloatRequest;
